<div class="tl-modal-content" data-testid="tl-modal-container">

  <p class="tl-modal__description" data-testid="tl-modal-description">
    <strong class="tl-modal__job-name">{{ jobName() }}</strong>
    has been requested to be translated into the following languages.
  </p>

  <div class="tl-modal__languages">

    <!-- Source language -->
    <span
      class="language-chip language-chip--source tl-modal__source-badge"
      role="note"
      [attr.aria-label]="'Source language: ' + sourceLanguage()"
      data-testid="tl-modal-source-badge"
    >
      {{ sourceLanguage() }}
    </span>

    <!-- Arrow separator -->
    <div class="tl-modal__arrow" aria-hidden="true">
      <span class="material-symbols-outlined">arrow_downward</span>
    </div>

    <!-- Target languages -->
    <!-- role="list" is required: Safari VoiceOver removes list semantics when list-style:none is applied -->
    <ul
      class="tl-modal__target-list language-chip-group language-chip-group--wrap"
      role="list"
      aria-label="Target languages"
      data-testid="tl-modal-target-chips-list"
    >
      @for (language of allTargetLanguages(); track language) {
        <li [attr.data-testid]="'tl-modal-target-chip-' + language.toLowerCase().replace(' ', '-')">
          <span class="language-chip language-chip--target" data-testid="tl-modal-target-chip">
            {{ language }}
          </span>
        </li>
      }
    </ul>

    <!-- Total count -->
    <p class="tl-modal__total" data-testid="tl-modal-total-count">
      ({{ totalCount() }} Total)
    </p>

  </div>
</div>
